import { render, staticRenderFns } from "./PaginationDetail.vue?vue&type=template&id=f4035378"
import script from "./PaginationDetail.vue?vue&type=script&lang=js"
export * from "./PaginationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports